import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { MobileTabBar } from './MobileTabBar';
import { PlusSheet } from './PlusSheet';
import { InstallGuide, INSTALL_GUIDE_SEEN_KEY } from './InstallGuide';
import { isStandalone, isMobileDevice } from '../../services/installPrompt';

const PUBLIC_PATHS = ['/', '/login', '/register', '/terms', '/nda', '/promos'];

// Coque « app native » : barre d'onglets mobile, feuille « Plus », guide d'installation.
export const AppShell = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [plusOpen, setPlusOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);

  const showTabs = !!user && !PUBLIC_PATHS.includes(location.pathname) && !location.pathname.startsWith('/shared-trail');

  useEffect(() => {
    document.body.classList.toggle('has-tabbar', showTabs);
    return () => document.body.classList.remove('has-tabbar');
  }, [showTabs]);

  // 1er lancement mobile dans le navigateur (non installé) → guide d'installation, une seule fois.
  useEffect(() => {
    if (!showTabs || isStandalone() || !isMobileDevice()) return;
    let seen = false;
    try { seen = !!localStorage.getItem(INSTALL_GUIDE_SEEN_KEY); } catch { /* ignore */ }
    if (!seen) setGuideOpen(true);
  }, [showTabs]);

  useEffect(() => {
    const open = () => setGuideOpen(true);
    window.addEventListener('obgh:open-install-guide', open);
    return () => window.removeEventListener('obgh:open-install-guide', open);
  }, []);

  return (
    <>
      {children}
      {showTabs && (
        <>
          <MobileTabBar onOpenPlus={() => setPlusOpen(true)} plusOpen={plusOpen} />
          <PlusSheet open={plusOpen} onOpenChange={setPlusOpen} onInstall={() => setGuideOpen(true)} />
        </>
      )}
      <InstallGuide open={guideOpen} onClose={() => setGuideOpen(false)} />
    </>
  );
};
